var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiGetListProffitSearchShareReceiveHeader } from '../../../../../actions/ProffitSearchReceiveHeaderAction';
import { apiGetListProffitSearchShareHeader } from '../../../../../actions/ProffitSearchShareHeaderAction';
import { apiGetListProffitSearchSummary } from '../../../../../actions/ProffitSearchSummaryAction';
import { wrapDispatch } from '../../../../../helpers/action';
import { propShape } from '../../../../../helpers/custom-prop-types';
import { getProffitSearchValues, isProffitSearchFreePlan, } from '../../../../../helpers/profile';
import { useSlideSearchCommonSearchKeyword } from '../../../../../helpers/use/proffit_search/common/useSlideSearchKeyword';
import { useSlideSearchRegenerateDevice } from '../../../../../helpers/use/proffit_search/common/useSlideSearchRegenerateDevice';
import { useDidMount, useUnmountRef } from '../../../../../helpers/use/useHook';
import BowserState from '../../../../../helpers/window/BowserState';
import SlideSearchRegenerateDeviceCompleteModal from '../../../../SlideSearch/RegenerateDevice/Modal/SlideSearchRegenerateDeviceCompleteModal';
import SlideSearchRegenerateDeviceModal from '../../../../SlideSearch/RegenerateDevice/Modal/SlideSearchRegenerateDeviceModal';
import ModalPortal from '../../../../Ui/Modal/ModalPortal';
import ProfessionalMyPageTopProffitSearchKeyword from './ProffitSearchKeyword';
import ProfessionalMyPageTopProffitSearchShare from './ProffitSearchShare';
import ProfessionalMyPageTopProffitSearchSlide from './ProffitSearchSlide';
/**
 * Proffit Searchの情報をマイページ上に表示するコンポーネント
 * @returns {JSX.Element}
 * @constructor
 */
const ProfessionalMyPageTopProffitSearchContent = (props) => {
    const { profile } = props;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const receive = useSelector((state) => state.proffitSearchReceiveHeader);
    const share = useSelector((state) => state.proffitSearchShareHeader);
    const informationTop = useSelector((state) => state.proffitSearchInformationTop);
    const { email } = profile;
    const { plan } = useMemo(() => getProffitSearchValues(profile), [profile]);
    const isFree = isProffitSearchFreePlan(plan);
    const { adminFileCount, comparedToLastWeekSlideCount, myFileCount, tags } = informationTop.summary || {};
    // 検索フォームの制御
    const { defaultValue, inputRef, onSubmit: onSubmitKeyword, } = useSlideSearchCommonSearchKeyword.useSlideSearchKeyword();
    // 端末再登録モーダルの制御
    const { hideCompleteModal, hideRegenerateModal, isShowCompleteModal, isShowRegenerateModal, loading, onClickRegenerate, showRegenerateModal, } = useSlideSearchRegenerateDevice.useSlideSearchRegenerateDeviceModal(false, dispatch, unmountRef);
    const { platform } = BowserState.bowser;
    const onClickShareItem = platform.type === 'mobile' ? showRegenerateModal : undefined;
    useDidMount(() => {
        // スライド関連の情報を取得
        const loadItems = () => __awaiter(void 0, void 0, void 0, function* () {
            yield Promise.all([
                wrapDispatch(dispatch, apiGetListProffitSearchSummary()),
                wrapDispatch(dispatch, apiGetListProffitSearchShareReceiveHeader()),
                wrapDispatch(dispatch, apiGetListProffitSearchShareHeader()),
            ]);
        });
        loadItems().then();
    });
    return (_jsxs("div", Object.assign({ className: 'professional_mypage_top_proffit_search' }, { children: [_jsxs("div", Object.assign({ className: 'proffit_search_inner' }, { children: [_jsx("div", Object.assign({ className: 'proffit_search_slide' }, { children: _jsx(ProfessionalMyPageTopProffitSearchSlide, { adminFileCount: adminFileCount, comparedToLastWeekSlideCount: comparedToLastWeekSlideCount, isFree: isFree, myFileCount: myFileCount, tags: tags }) })), _jsx("div", Object.assign({ className: 'proffit_search_share' }, { children: _jsx(ProfessionalMyPageTopProffitSearchShare, { onClickItem: onClickShareItem, receive: receive, share: share }) })), _jsx("div", Object.assign({ className: 'proffit_search_keyword' }, { children: _jsx(ProfessionalMyPageTopProffitSearchKeyword, { defaultValue: defaultValue, inputRef: inputRef, onSubmit: onSubmitKeyword }) }))] })), _jsxs(ModalPortal, { children: [_jsx(SlideSearchRegenerateDeviceModal, { hideModal: hideRegenerateModal, isShow: isShowRegenerateModal, loading: loading, onClick: onClickRegenerate }), _jsx(SlideSearchRegenerateDeviceCompleteModal, { email: email, hideModal: hideCompleteModal, isShow: isShowCompleteModal })] })] })));
};
ProfessionalMyPageTopProffitSearchContent.propTypes = {
    profile: propShape().isRequired,
};
export default ProfessionalMyPageTopProffitSearchContent;
